import React from "react";
import "./Shane_Scott.css";



const Shane_Scott = () => (

  <div className='Shane_ScottMain'>

  <a href={"https://www.linkedin.com/in/shane-r-scott/"} 
  target={"_blank"}><h3 className="text-center" >Shane R. Scott</h3></a>
 
<p>Let me tell you a bit about Charles Roberts. He’s the sort of person who 
appreciates the distinction between intelligence and knowledge, and the 
importance of both. He has no shortage of either of these things, and 
remains committed to continuous learning. He’s also the sort of fellow 
that you’ll like to have on your team, when things get tough.</p>

<p>When I met him, Charles already had a wealth of computer science 
(and programming) skill. We found ourselves in a programming course, 
together, even though I did not (and do not) possess nearly that same level 
of ability. He was taking the course to further add to his coding skills, 
as I was working to hone just my first few.</p>

<p>This is what initially defined Charles, in my mind. I saw that a man 
of great ability was going out of his way to become yet more capable. 
His example has served to better impress upon me the great value - in 
this industry, especially - of continuous, and enthusiastic, intellectual 
curiosity. I’ve become a better programmer because of this, and I’ll 
continue to benefit from it.</p>

<p>That’s just one lesson I’ve learned from Charles. In the interest of 
reasonable brevity, I’ll resist the urge to try to explain all such 
lessons. Still, I do want to go into some detail about at least one 
more standout attribute.</p>

<p>Charles Roberts, a smart and capable guy, is also a “clutch player.” 
You may know the term from sportswriters, referring to those that “come 
through for the team in the clutch.” Charles has been my teammate, and 
while he’s a steady contributor of great reliability, I’ve found that 
he can prove yet more valuable when a project seems to be in trouble.</p>

<p>In the course of work for a major group project, a series of problems 
pushed the effort “to the brink.” One teammate gave up on our work, 
entirely, leaving the group in a very difficult situation, especially 
with regard to completing the project application’s user interface. 
As we were desperately close to a hard deadline, I estimated our 
collective chance of success to be about twenty percent. I actually 
felt like quite the optimist, in doing so.</p>

<p>Refusing to accept the prospect of looming failure, Charles rallied 
his teammates to do the same. Taking control of the UI work, he became 
greatly responsible for bringing the project to a successful conclusion. 
He did this, even as he had already proven the greatest single contributor 
to the code base, and completed all of his work. With extraordinary 
effort, going well beyond assigned or expected responsibility, he saved 
that project. Yes, Charles is “clutch.”</p>

<p>In addition to being a smart man, a skilled and “clutch” coder, 
and a committed scholar, Charles Roberts is also remarkably kind. 
Because of this, in part, he makes friends easily, and implicitly 
encourages the efforts of others. This aspect of his personality makes 
those around him better at their jobs, in a way that is both effortless 
and valuable.</p>

<p>You should get to know Charles. It will be to your benefit, and that of your work</p>

  </div>
);

export default Shane_Scott;


// WEBPACK FOOTER //
// ./src/components/AboutMe/Shane_Scott.js